/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import "./styles.scss";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import cn from "classnames";
import { ImageDataLike, StaticImage } from "gatsby-plugin-image";
import { Typography } from "@trussle/external-components";
import { IContentfulImage } from "../../types/IContentfulImage";
import { IContentfulHeroProps } from "../../types/IHero";
import CTACard from "../CTACard";

const Hero5: React.FC<IContentfulHeroProps> = ({
  heading1,
  heading2,
  callToActions,
  optionLinks,
  variant,
}) => {
  const GetBgImageLeft: React.FC<{variant?: string}> = ({ variant }) => (
    variant === "orange" ? (
      <StaticImage
        src="../../static/purchase-bg-left.png"
        alt="title-icon"
        placeholder="none"
        quality={100}
      />
    ) : (
      <StaticImage
        src="../../static/remortgage-bg-left.png"
        alt="title-icon"
        placeholder="none"
        quality={90}
      />
    )
  );
  const GetBgImageRight: React.FC<{variant?: string}> = ({ variant }) => (
    variant === "orange" ? (
      <StaticImage
        src="../../static/purchase-bg-right.png"
        alt="title-icon"
        placeholder="none"
        quality={100}
      />
    ) : (
      <StaticImage
        src="../../static/remortgage-bg-right.png"
        alt="title-icon"
        placeholder="none"
        quality={90}
      />
    )
  );
  return (
    <div className="hero5__container">
      <div className="hero5__background__image__left">
        <GetBgImageLeft variant={variant} />
      </div>
      <div className="hero5">
        <section className="hero5__container__heading" aria-label="Hero heading">
          {heading1 && (
          <Typography variant="h1" component="div" classes="hero5__heading">{renderRichText(heading1)}</Typography>
          )}
          {heading2 && (
          <div className="hero5__subheading">{renderRichText(heading2)}</div>
          )}
        </section>
        <section className={cn("hero5__ctas", variant)} aria-label="Hero call to actions">
          {callToActions && callToActions.map((cta, index) => (
            <CTACard
              key={index + cta.title}
              variant={variant}
              withOptions={false}
              title={cta.title}
              subTitle={cta.subtitle}
              url={cta.url}
              icon={cta.image as IContentfulImage & ImageDataLike}
            />
          ))}
          <CTACard
            variant={variant}
            title="I want to..."
            subTitle="Or see your options"
            withOptions
            links={optionLinks}
          />
          <div />
        </section>
      </div>
      <div className="hero5__background__image__right">
        <GetBgImageRight variant={variant} />
      </div>
    </div>
  );
};

export default Hero5;
